import React from "react";
var __jsx = React.createElement;
import { faCheck, faCopy } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActionIcon } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { hasValue } from "@/utils/format";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** A compact labelled pill with an on-hover copy button for displaying report metadata values. */
export function MetaPill(_ref) {
  var label = _ref.label,
    value = _ref.value,
    isAccented = _ref.isAccented;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    copied = _useState[0],
    setCopied = _useState[1];
  if (!hasValue(value)) return null;
  var text = Array.isArray(value) ? value.join(", ") : value;
  var onCopy = function onCopy(e) {
    trackEvent(ANALYTICS_EVENTS.META_PILL_COPY, {
      label: label
    });
    e.stopPropagation();
    navigator.clipboard.writeText(text)["catch"](function () {});
    setCopied(true);
    setTimeout(function () {
      return setCopied(false);
    }, 1200);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "group inline-flex items-center gap-1.5 bg-sds-base-default border border-sds-base-default rounded-sds-100 px-3 py-1 whitespace-nowrap"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-caps text-sds-base-tertiary"
  }, label), /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small ".concat(isAccented ? "text-sds-brand-default" : "text-sds-base-default")
  }, text), /*#__PURE__*/React.createElement(ActionIcon, {
    "data-testid": "meta-pill-copy-".concat(label),
    variant: "transparent",
    size: 14,
    title: copied ? t("label.copied", {
      defaultValue: "Copied"
    }) : t("label.copy_value", {
      defaultValue: "Copy {{label}}",
      label: label
    }),
    "aria-label": t("label.copy_value", {
      defaultValue: "Copy {{label}}",
      label: label
    }),
    onClick: onCopy,
    className: "-mr-1 transition-opacity duration-150 focus:opacity-100 ".concat(copied ? "opacity-100 text-sds-brand-default" : "opacity-0 group-hover:opacity-100 text-sds-base-tertiary hover:text-sds-brand-default")
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: copied ? faCheck : faCopy,
    className: "w-[10px] h-[10px]"
  })));
}